import React, { useState, useEffect } from 'react'
import { Alert, Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLifeRing } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { message } from 'antd'

import ListTopBar from '../../components/ListTopBar'

import PaymentsTable from './partials/PaymentsTable'
import NewTicketModal from '../Tickets/partials/NewTicketModal'

import { getPayments } from './services'
import { getUri } from '../../services/springCenfApi'
import { storeDownloadToken } from '../DownloadTokens/services'
import { handleError, parsePagination } from '../../helpers'

export default function PaymentsList() {
	const user = useSelector(state => state.auth.user)
	const [payments, setPayments] = useState(null)
	const [filterType, setFilterType] = useState('paymentDetails.invoice.consecutive')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showTicketsModal, setShowTicketsModal] = useState(false)
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		!payments && getPayments({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			'filter[supplier_id]': user.id,
			include: 'paymentDetails.invoice.certificates',
			sort: '-paid_at'
		})
			.then(res => {
				setPayments(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ payments, pagination, filterType, filterValue, user ])

	const handleExport = () => {
		setLoading(true)
		let token = new Date().getTime()
		storeDownloadToken({ type: `Descarga de Pagos Recibidos`, token, supplier_id: user.id })
			.then(() => {
				message.info('Generando reporte en nueva pestaña')
				window.open(`${getUri()}/reports/export/payments/${user.id}/${token}`)
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<React.Fragment>
			<ListTopBar 
				title="Pagos Recibidos"
				subtitle="Listado de pagos realizados a su nombre"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setPayments(null)}
				options={[
					{ label: 'Buscar por consecutivo factura', value: 'paymentDetails.invoice.consecutive' },
					{ label: 'Buscar por fecha (YYYY-MM-DD)', value: 'paid_at' },
					{ label: 'Buscar por consecutivo interno', value: 'sku' },
				]}
				onExport={handleExport}
				disabledExport={loading}
			/>
			<div className='inline-block full-width'>
				<Alert className='p-5 mt-10 mb-10' color='info'>A continuación visualizará los pagos que se realizaron a su nombre. Podrá consultar el detalle de los mismos desde este módulo.</Alert>
			</div>
			<PaymentsTable 
				payments={payments}
				reload={() => setPayments(null)}
				pagination={pagination}
				setPagination={setPagination}
			/>			
			<Button color='warning' size="sm" onClick={() => setShowTicketsModal(true)}>
				<FontAwesomeIcon icon={faLifeRing} className='mr-5' />
			   No encuentro el pago que busco
			</Button>
			{ showTicketsModal && (
				<NewTicketModal
					visible
					onClose={() => setShowTicketsModal(false)}
					scope="payments"
				/>
			)}
		</React.Fragment>
	)
}